import React, { useEffect, useState } from 'react'
import ContentWrapper from '../../components/contentwrapper/ContentWrapper'
import { FaRegHandPointRight } from "react-icons/fa";
import { Link, useNavigate } from 'react-router-dom';
import { addSingleDataAPI, fetchAllDataAPI } from '../../utils/api';
import { toast } from 'react-toastify';
import withAuth from '../../utils/withAuth';
import { Col, Form, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet';

const AddEmployee = () => {
    const navigate = useNavigate();
    const [values, setUserValue] = useState();
    const [designation, setDesignation] = useState([]);
    const [company, setCompany] = useState([]);
    const [validated, setValidated] = useState(false);

    useEffect(() => {
        getDesignation();
        getCompany();
    }, []);

    const getDesignation = () => {
        fetchAllDataAPI('hr-active-designation').then((res) => {
            if (res.data.status === 1) {
                setDesignation(...[res.data.designation]);
            }
            else {
                toast.error("Check you connection!!");
            }
        })
    }

    const getCompany = () => {
        fetchAllDataAPI('hr-active-company').then((res) => {
            if (res.data.status === 1) {
                setCompany(...[res.data.company]);
            }
            else {
                toast.error("Check you connection!!");
            }
        })
    }

    const handleInputs = e => {
        setUserValue({
            ...values,
            [e.target.name]: e.target.value,
        });
    };
    const handleAddEmployee = (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.stopPropagation();
        }
        else {
            try {
                addSingleDataAPI('hr-add-employee', values).then((res) => {
                    if (res.data.status === 1) {
                        toast.success("Employee has been added successfully!");
                        navigate('/employee');
                    }
                    else if (res.data.status === 2) {
                        toast.warning("This Employee already exit!!");
                    }
                    else {
                        toast.error("Something Wrongs!!");
                    }
                })
            }
            catch (error) {
                toast.error("Something is worng!!");
            }
        }
        setValidated(true);
    }

    return (
        <div className="designationPage">
            <Helmet>
                <title>SATKARTAR::HR::ADD Employee</title>
            </Helmet>
            <ContentWrapper>
                <div className="page-wrapper breadcum">
                    <div className="page-breadcrumb btnbreadcrum d-none d-sm-flex align-items-center justify-between">
                        <div className="">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb mb-0 p-0">
                                    <li className="breadcrumb-item">
                                        <Link to="/dashboard">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/employee">Employee</Link>
                                    </li>
                                    <li className="breadcrumb-item" aria-current="page">ADD Employee</li>
                                </ol>
                            </nav>
                        </div>
                    </div>

                    <Row>
                        <Col sm={12} md="6" className="colclass">
                            <div className="employee mt-2">
                                <div className="card border-top border-0 border-4 border-danger">
                                    <div className="card-body">
                                        <div className="card-title d-flex align-items-center">
                                            <div className="form-heading card-title d-flex align-items-center">
                                                <h5 className="mb-0 text-danger">Basic information</h5>
                                            </div>
                                        </div>
                                        <hr />
                                        <Form noValidate validated={validated} onSubmit={handleAddEmployee} method="post">
                                            <Row className="mb-3">
                                                <Form.Group as={Col} md="6" controlId="validationCustom01">
                                                    <Form.Label>Enter Name</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        placeholder="Enter Name"
                                                        name="emp_name"
                                                        onChange={handleInputs}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid name
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom01">
                                                    <Form.Label>Enter Emp Code</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        placeholder="Enter EMP Code"
                                                        name="emp_code"
                                                        onChange={handleInputs}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid emp code
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom01">
                                                    <Form.Label>Enter Mobile Number</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        placeholder="Enter Mobile Number"
                                                        name="emp_mobile"
                                                        onChange={handleInputs}
                                                        pattern="[6789][0-9]{9}"
                                                        maxLength={10}
                                                        minLength={10}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid mobile number
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom01">
                                                    <Form.Label>Enter Company Email</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        placeholder="Enter Company Email"
                                                        name="emp_company_email"
                                                        onChange={handleInputs}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid email address
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom02">
                                                    <Form.Label>Select Role</Form.Label>
                                                    <Form.Select required
                                                        placeholder="Member Type"
                                                        name="emp_job_role"
                                                        onChange={handleInputs}>
                                                        <option value="">Select Role</option>
                                                        <option value="Center Cluster Head">Center Cluster Head</option>
                                                        <option value="Center Head">Center Head</option>
                                                        <option value="MIS">MIS</option>
                                                        <option value="AMIS">AMIS</option>
                                                        <option value="TL">TL</option>
                                                        <option value="ATL">ATL</option>
                                                        <option value="Digital Marketing">Digital Marketing</option>
                                                        <option value="PPC">PPC</option>
                                                        <option value="Developer">Developer</option>
                                                        <option value="Cotent Writer">Cotent Writer</option>
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid role
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom02">
                                                    <Form.Label>Select Designation</Form.Label>
                                                    <Form.Select required
                                                        placeholder="Member Type"
                                                        name="emp_designation"
                                                        onChange={handleInputs}>
                                                        <option value="">Select Designation</option>
                                                        {designation?.map((designation) => (
                                                            <option value={designation?.designation_id}>{designation?.designation_name}</option>
                                                        ))}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid Designation
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom01">
                                                    <Form.Label>Department</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        placeholder="Department"
                                                        name="emp_department"
                                                        onChange={handleInputs}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid Department
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom01">
                                                    <Form.Label>Date Of Joining</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="date"
                                                        placeholder="Department"
                                                        name="emp_joining_date"
                                                        onChange={handleInputs}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid DOJ
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom01">
                                                    <Form.Label>Seating Location</Form.Label>
                                                    <Form.Control
                                                        required
                                                        type="text"
                                                        placeholder="Seating Location"
                                                        name="emp_seating_location"
                                                        onChange={handleInputs}
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid Location
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom02">
                                                    <Form.Label>Select Company Name</Form.Label>
                                                    <Form.Select required
                                                        placeholder="Member Type"
                                                        name="emp_leave_policy"
                                                        onChange={handleInputs}>
                                                        <option value="">Select Employeer</option>
                                                        {company?.map((company) => (
                                                            <option value={company?.company_id}>{company?.company_name}</option>
                                                        ))}
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid employeer
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom02">
                                                    <Form.Label>Select Job Type</Form.Label>
                                                    <Form.Select required
                                                        placeholder="Member Type"
                                                        name="emp_job_type"
                                                        onChange={handleInputs}>
                                                        <option value="">Select Job Type</option>
                                                        <option value="Full Time">Full Time</option>
                                                        <option value="Part Time">Part Time</option>
                                                        <option value="Permanent">Permanent</option>
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid job type
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <Form.Group as={Col} md="6" controlId="validationCustom02">
                                                    <Form.Label>Select Work From</Form.Label>
                                                    <Form.Select required
                                                        placeholder="Member Type"
                                                        name="emp_work_form"
                                                        onChange={handleInputs}>
                                                        <option value="">Select Work From</option>
                                                        <option value="Work From Office">Work From Office</option>
                                                        <option value="Work From Home">Work From Home</option>
                                                        <option value="working from client location">working from client location</option>
                                                    </Form.Select>
                                                    <Form.Control.Feedback type="invalid">
                                                        <FaRegHandPointRight /> Please provide a valid Work From
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>
                                            <button type="submit" className="btnsubmit">Submit</button>
                                        </Form>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </ContentWrapper >
        </div >
    )
}

export default withAuth(AddEmployee)